import React, {useState} from "react";
import {
    Input,
    Button,
    Typography, Tooltip, Checkbox
} from "@material-tailwind/react";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {ExclamationCircleIcon} from "@heroicons/react/20/solid";

export default function RegisterForm() {

    const [sifraKorisnika, setSifraKorisnika] = useState("");
    const [email, setEmail] = useState("");
    const [lozinka, setLozinka] = useState("");
    const [povtrdaLozinke, setPovtrdaLozinke] = useState("");
    const [errorPassword] = useState(false);
    const [registerError, setRegisterError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [checkboxError, setCheckboxError] = useState(false);

    const navigate = useNavigate();

    const handleRegisterSubmit = async (e) => { e.preventDefault();

        try {
            // Provera da li je polje šifre korisnika prazno
            if (!sifraKorisnika || sifraKorisnika.trim() === "") {
                setRegisterError(true);
                setErrorMessage("Šifra korisnika ne može biti prazna.");
                return;
            }

            if (lozinka !== povtrdaLozinke) {
                setRegisterError(true);
                setErrorMessage("Lozinke se ne poklapaju.");
                return;
            }

            if (!isChecked) {
                setRegisterError(true);
                setErrorMessage("Morate se saglasiti sa politikom privatnosti i uslovima korišćenja.");
                return;
            }

            const API_URL = process.env.REACT_APP_API_URL;

            await axios.post(`${API_URL}/auth/register`, {
                sifraKorisnika,
                email,
                lozinka
            });
            navigate("/verify");
        } catch (err) {
            setRegisterError(true);
            // Ako backend vraća poruku greške
            if (err.response && err.response.data) {
                setErrorMessage(err.response.data);
            } else {
                setErrorMessage("Došlo je do greške. Pokušajte ponovo.");
            }
        }
    }

    const TooltipConfirmPasswordError = () => {
        return (
            <div className="p-1">
                <p className=" text-red-500 font-bold">{errorMessage}</p>
            </div>
        );
    };
    function storeScrollPosition() {
        sessionStorage.setItem('scrollPosition', window.scrollY.toString());
    }

    return (
        <div className="flex flex-col items-center justify-center w-full px-6 py-4 sm:px-8 sm:py-6">
            <Typography variant="h4" color="blue-gray" className="text-center mb-4 font-semibold">
                Registruj se
            </Typography>

            <form className="mt-6 mb-2 w-full sm:max-w-md" onSubmit={handleRegisterSubmit}>
                <div className="mb-4 flex flex-col gap-6">
                    <Input
                        color="blue"
                        size="lg"
                        label="Šifra korisnika - mesto isporuke"
                        value={sifraKorisnika}
                        onChange={(e) => setSifraKorisnika(e.target.value)}
                        className="rounded-lg border-2"
                    />
                    <Input
                        color="blue"
                        size="lg"
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="rounded-lg border-2"
                    />
                    <Input
                        color="blue"
                        type="password"
                        size="lg"
                        label="Lozinka"
                        value={lozinka}
                        onChange={(e) => setLozinka(e.target.value)}
                        className="rounded-lg border-2"
                    />
                    <Input
                        color="blue"
                        type="password"
                        size="lg"
                        label="Potvrdi lozinku"
                        value={povtrdaLozinke}
                        onChange={(e) => setPovtrdaLozinke(e.target.value)}
                        error={errorPassword}
                        className="rounded-lg border-2"
                        icon={
                            errorPassword && (
                                <Tooltip content={<TooltipConfirmPasswordError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                                    <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                                </Tooltip>
                            )
                        }
                    />
                </div>

                <Typography
                    variant="small"
                    color="gray"
                    className="flex items-center font-normal"
                >
                    <a
                        href="/Uputstvo - Uvid u potrošnju.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                    >
                        Uputstvo za korišćenje portala "Uvid u potrošnju"
                    </a>
                </Typography>

                <Checkbox
                    color={checkboxError ? "red" : "blue"}  // Crvena boja ako je greška
                    checked={isChecked}  // Veza sa stanjem
                    onChange={(e) => {
                        setIsChecked(e.target.checked);  // Ažuriranje stanja
                        setCheckboxError(false);  // Resetovanje greške kad je označen
                    }}
                    label={
                        <Typography
                            variant="small"
                            color="gray"
                            className="flex flex-wrap items-center font-normal mt-4"
                        >
                            Saglasan/na sam sa&nbsp;
                            <a
                                href="/Politika%20privatnosti.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                            >
                                politikom privatnosti
                            </a>
                            &nbsp;i&nbsp;
                            <a
                                href="/Uslovi%20koriscenja.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 hover:underline"
                            >
                                uslovima korišćenja
                            </a>.
                        </Typography>
                    }
                    containerProps={{ className: "-ml-2.5 mt-4" }}
                />

                {/* Error message */}
                {registerError && (
                    <div className="flex items-center justify-center mt-4">
                        <Typography className="text-red-500 mr-2">Ups! Doslo je do greske</Typography>
                        <Tooltip content={<TooltipConfirmPasswordError />} placement="top-end" size="sm" className="bg-gray-100 border-1 border-red-700">
                            <ExclamationCircleIcon className="text-red-500 h-5 w-5" />
                        </Tooltip>
                    </div>
                )}

                {/* Register Button */}
                <Button
                    color="green"
                    className="text-white font-semibold py-3 px-6 sm:py-4 sm:px-8 rounded-full shadow-lg bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-r hover:from-blue-600 hover:via-blue-700 hover:to-blue-800 transition-all duration-300 mt-12 sm:mt-16"
                    fullWidth
                    type="submit"
                    onClick={storeScrollPosition}
                >
                    Registruj se
                </Button>
            </form>
        </div>
    );
}